export enum TvSkinEnum {
    Default = "default",
    TVGuest = "TVGuest",
    TVOne = "TVOne",
    Simplex = "simplex"
}
